import { ApiSubUrls, Apis } from 'enums/api-constants'
import { fetchGeneralData } from 'queries/fetchData'
import { TrailerRGDData } from 'queries/trailer/trailer-schedule-response'

export const fetchTrailerRGD = fetchGeneralData<TrailerRGDData>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/inbound_trailers/rgd_trailers`,
)
